import { render } from "./ButtonEl.vue?vue&type=template&id=422eeddd&scoped=true"
import script from "./ButtonEl.vue?vue&type=script&lang=js"
export * from "./ButtonEl.vue?vue&type=script&lang=js"

import "./ButtonEl.vue?vue&type=style&index=0&id=422eeddd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422eeddd"]])

export default __exports__